

import { computed, ref } from 'vue'
import AuthRepository from '@/services/AuthRepository'
import { useToast } from "primevue/usetoast";
import { useRouter } from 'vue-router';
import {useStore} from "vuex";
import {useConfirm} from "primevue/useconfirm";
import {UserUpdate} from "@/models/userUpdate";
import theoDoiRepository from "@/services/TheoDoiRepository";
import {Dashboard} from "@/models/dashboard";
import {DashboardDetail} from "@/models/dashboardDetail";
import { Chart as ChartJS, Title, Tooltip, Legend, LineElement, PointElement, LinearScale, CategoryScale } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
ChartJS.register(Title, Tooltip, Legend, LineElement, PointElement, LinearScale, CategoryScale, ChartDataLabels);

export default {
  props: {
    id: Number,
  },

  setup(props) {
    const router = useRouter();
    const userUpdate = ref({} as UserUpdate);
    const toast = useToast();
    const store = useStore();
    const error = ref(null);
    userUpdate.value.password = "";
    const dashboard = ref({} as Dashboard);
    const list = ref([] as DashboardDetail[]);

    theoDoiRepository.dashboard()
        .then((response) => {
          dashboard.value = response.data;
        })
        .catch(err => {
          toast.add({
            severity: 'error',
            summary: 'Lỗi',
            detail: err.response.data,
            life: 2000
          });
        });
    theoDoiRepository.getListDashboardIn10Day()
        .then((response) => {
          list.value = response.data;
        })
        .catch(err => {
          toast.add({
            severity: 'error',
            summary: 'Lỗi',
            detail: err.response.data,
            life: 2000
          });
        })

        const currency = (val) => {
          return new Intl.NumberFormat('vi-VN', { maximumFractionDigits: 2, style: 'currency', currency: 'VND' }).format(val);
        };


    const lineStylesData = computed(() => {
      //console.log("################ loadData totalData: ");
      const data = list.value;
      console.log("################ loadData data: " + JSON.stringify(data));
      return {
        labels: data.map(x => x.thoiGian),
        datasets: [
          {
            label: 'Số lượt khám bệnh',
            data: data.map(x => x.slKham),
            fill: true,
            borderColor: '#42A5F5',
            tension: .4,
            backgroundColor: '#aed3f0'
          }
        ]
      }
    });



    const lineStylesDataIn = computed(() => {
      //console.log("################ loadData totalData: ");
      const data = list.value;
      console.log("################ loadData data: " + JSON.stringify(data));
      return {
        labels: data.map(x => x.thoiGian),
        datasets: [
          {
            label: 'Số bệnh nhân cũ',
            data: data.map(x => x.bN_Cu),
            fill: true,
            borderColor: '#ecb913',
            tension: .4,
            backgroundColor: '#f8f1c9'
          }
        ]
      }
    });
    const lineStylesDataNew = computed(() => {
      //console.log("################ loadData totalData: ");
      const data = list.value;
      console.log("################ loadData data: " + JSON.stringify(data));
      return {
        labels: data.map(x => x.thoiGian),
        datasets: [
          {
            label: 'Số bệnh nhân mới',
            data: data.map(x => x.bN_Moi),
            fill: true,
            borderColor: '#a812b1',
            tension: .4,
            backgroundColor: '#e497e9'
          }
        ]
      }
    });

    const lineStylesDataNoiTru = computed(() => {
      //console.log("################ loadData totalData: ");
      const data = list.value;
      console.log("################ loadData data: " + JSON.stringify(data));
      return {
        labels: data.map(x => x.thoiGian),
        datasets: [
          {
            label: 'Viện phí nội trú',
            data: data.map(x => x.vienPhi_NoiTru),
            fill: true,
            borderColor: '#03a38f',
            tension: .4,
            backgroundColor: '#73f9f7'
          }
        ]
      }
    });

    const lineStylesDataNgoaiTru = computed(() => {
      //console.log("################ loadData totalData: ");
      const data = list.value;
      console.log("################ loadData data: " + JSON.stringify(data));
      return {
        labels: data.map(x => x.thoiGian),
        datasets: [
          {
            label: 'Viện phí ngoại trú',
            data: data.map(x => x.vienPhi_NgoaiTru),
            fill: true,
            borderColor: '#d6402b',
            tension: .4,
            backgroundColor: '#d69f98'
          }
        ]
      }
    });

    const basicOptions = ref(
        {
          plugins: {
            legend: {
              labels: {
                color: '#495057'
              }
            }
          },
          scales: {
            x: {
              ticks: {
                color: '#495057'
              },
              grid: {
                color: '#ebedef'
              }
            },
            y: {
              ticks: {
                color: '#495057'
              },
              grid: {
                color: '#ebedef'
              }
            }
          }
        }
    );

    const basicOptionsLine = {
      responsive: true,
      maintainAspectRatio: false, // Không giữ tỉ lệ, cho phép set chiều cao qua CSS
      layout: {
        padding: {
          top: 20,
          bottom: 20
        }
      },
      elements: {
        line: {
          borderWidth: 3
        },
        point: {
          radius: 3,
          hitRadius: 8,
          hoverRadius: 6
        }
      },
      plugins: {
        legend: {
          labels: {
            color: '#495057',
            font: {
              weight: 'bold',
              size: 12
            }
          }
        },
        tooltip: {
          enabled: true
        },
        datalabels: {
          color: '#111',
          font: {
            weight: 'bold',
            size: 12
          },
          backgroundColor: 'rgba(255,255,255,0.85)',
          borderRadius: 4,
          padding: 4,
          anchor: 'end',
          align: 'top',
          offset: 6,
          clamp: true,
          clip: false
        }
      },
      scales: {
        y: {
          beginAtZero: true,
          grace: '15%'
        }
      }
    };



    const chartOptions = computed(() => {
      const data = list.value;
      return {
        chart: {
          type: 'area',
          dropShadow: {
            enabled: true,
            color: '#000',
            top: 18,
            left: 7,
            blur: 10,
            opacity: 0.2
          },
          toolbar: {
            show: false
          }
        },
        colors: ['#05a38f'],
        dataLabels: {
          enabled: true,
          background: {
            enabled: true,
            foreColor: '#fff',
            borderRadius: 2,
            padding: 4,
            opacity: 0.9
          },
          style: {
            fontSize: '11px',
            fontWeight: 'bold'
          },
          offsetY: -10,
          textAnchor: 'middle',
          formatter: function (val) {
            return new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(val);
          }
        },
        stroke: {
          curve: 'smooth'
        },
        title: {
          // text: 'Biểu đồ viện phí ngoại trú',
          align: 'left'
        },
        grid: {
          borderColor: '#e7e7e7',
          row: {
            colors: ['transparent'], // takes an array which will be repeated on columns
            opacity: 0.5
          },
        },
        markers: {
          size: 1
        },
        xaxis: {
          categories: data.map(x => x.thoiGian),
        },
        legend: {
          position: 'top',
          horizontalAlign: 'right',
          floating: true,
          offsetY: -25,
          offsetX: -5
        }
      }
    })

    const series = computed(() => {
      const data = list.value;
      return [
        {
          name: "Viện phí",
          data: data.map(x => x.vienPhi_NgoaiTru)
        }
      ]
    })

    const chartOptionsNoiTru = computed(() => {
      const data = list.value;
      return {
        chart: {
          type: 'area',
          dropShadow: {
            enabled: true,
            color: '#000',
            top: 18,
            left: 7,
            blur: 10,
            opacity: 0.2
          },
          toolbar: {
            show: false
          },
        },
        colors: ['#D65B4A'],
        dataLabels: {
          enabled: true,
          background: {
            enabled: true,
            foreColor: '#fff',
            borderRadius: 2,
            padding: 4,
            opacity: 0.9
          },
          style: {
            fontSize: '11px',
            fontWeight: 'bold'
          },
          offsetY: -10,
          textAnchor: 'middle',
          formatter: function (val) {
            return new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(val);
          }
        },
        stroke: {
          curve: 'smooth'
        },
        title: {
          // text: 'Biểu đồ viện phí nội trú',
          align: 'left'
        },
        grid: {
          borderColor: '#e7e7e7',
          row: {
            colors: ['transparent'], // takes an array which will be repeated on columns
            opacity: 0.5
          },
        },
        markers: {
          size: 1
        },
        xaxis: {
          categories: data.map(x => x.thoiGian),
        },
        legend: {
          position: 'top',
          horizontalAlign: 'right',
          floating: true,
          offsetY: -25,
          offsetX: -5
        }
      }
    })

    const seriesNoiTru = computed(() => {
      const data = list.value;
      return [
        {
          name: "Viện phí",
          data: data.map(x => x.vienPhi_NoiTru)
        }
      ]
    })

    const formatMoney = (val) => {
      return new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(val);
    }
    return {
      dashboard,
      currency,
      lineStylesData,
      basicOptions,
      basicOptionsLine,
      lineStylesDataIn,
      lineStylesDataNew,
      lineStylesDataNoiTru,
      lineStylesDataNgoaiTru,
      chartOptions,
      series,
      chartOptionsNoiTru,
      seriesNoiTru,
      formatMoney
    }
  }
}

